import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, withModifiers as _withModifiers, vModelText as _vModelText, withKeys as _withKeys, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle } from "vue"
import _imports_0 from './assets/logo_wwt.png'
import _imports_1 from './assets/ip-ussrc.png'


const _hoisted_1 = { id: "main-content" }
const _hoisted_2 = {
  class: "modal",
  id: "modal-loading"
}
const _hoisted_3 = { class: "hamb-icon-container" }
const _hoisted_4 = { class: "intro-modal" }
const _hoisted_5 = { class: "intro-modal-title" }
const _hoisted_6 = { class: "intro-body-wrap" }
const _hoisted_7 = {
  key: 1,
  class: "search-overlay"
}
const _hoisted_8 = {
  key: 0,
  class: "search-results"
}
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "search-result-name" }
const _hoisted_11 = { class: "search-result-cat" }
const _hoisted_12 = { class: "ping-layer" }
const _hoisted_13 = {
  key: 2,
  class: "reticle-toggle-wrap"
}
const _hoisted_14 = ["title"]
const _hoisted_15 = {
  key: 3,
  class: "reticle-overlay"
}
const _hoisted_16 = { class: "popover-name" }
const _hoisted_17 = { class: "popover-details" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { class: "checkboxes-container" }
const _hoisted_20 = { class: "center-buttons" }
const _hoisted_21 = ["disabled", "max"]
const _hoisted_22 = { class: "bg-slider-text month-label" }
const _hoisted_23 = { class: "crossfade-row" }
const _hoisted_24 = { class: "bg-slider-text cf-label cf-label-right" }
const _hoisted_25 = { class: "sky-picker-wrap" }
const _hoisted_26 = { class: "sky-picker-dropdown" }
const _hoisted_27 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WorldWideTelescope = _resolveComponent("WorldWideTelescope")!
  const _component_wwt_hud = _resolveComponent("wwt-hud")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_app = _resolveComponent("v-app")!

  return (_openBlock(), _createBlock(_component_v_app, {
    id: "app",
    style: _normalizeStyle(_ctx.cssVars)
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_WorldWideTelescope, {
          "wwt-namespace": _ctx.wwtNamespace,
          onPointerdown: _ctx.wwtOnPointerDown,
          onPointermove: _ctx.wwtOnPointerMove,
          onPointerup: _ctx.wwtOnPointerUp
        }, null, 8, ["wwt-namespace", "onPointerdown", "onPointermove", "onPointerup"]),
        false
          ? (_openBlock(), _createBlock(_component_wwt_hud, {
              key: 0,
              "wwt-namespace": _ctx.wwtNamespace,
              location: {top: '5rem', right: '1rem'},
              "offset-center": {x: 0, y: 0},
              "other-variables": {position3D: _ctx.position3D, position2D: _ctx.position2D, mode: _ctx.modeReactive},
              "text-shadow": "none",
              "font-size": "0.8em"
            }, null, 8, ["wwt-namespace", "other-variables"]))
          : _createCommentVNode("", true),
        _createVNode(_Transition, { name: "fade" }, {
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("div", _hoisted_2, _cache[27] || (_cache[27] = [
              _createElementVNode("div", { class: "container" }, [
                _createElementVNode("div", { class: "spinner" }),
                _createElementVNode("p", null, "Loading …")
              ], -1)
            ]), 512), [
              [_vShow, _ctx.isLoading]
            ])
          ]),
          _: 1
        }),
        _cache[50] || (_cache[50] = _createElementVNode("link", {
          rel: "stylesheet",
          href: "https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css"
        }, null, -1)),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", {
            class: "menu-toggle",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleMenu && _ctx.toggleMenu(...args)))
          }, _cache[28] || (_cache[28] = [
            _createElementVNode("i", {
              class: "fas fa-sliders-h",
              style: {"font-size":"24px"}
            }, null, -1)
          ])),
          _createElementVNode("ul", {
            class: _normalizeClass(["hamb-menu-container", {'show': _ctx.isMenuOpen }])
          }, [
            _createElementVNode("li", {
              class: "hamb-menu-items",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openIntro && _ctx.openIntro(...args)))
            }, _cache[29] || (_cache[29] = [
              _createElementVNode("i", { class: "fas fa-regular fa-info-circle" }, null, -1),
              _createTextVNode(" Overview ")
            ])),
            _createElementVNode("li", {
              class: "hamb-menu-items",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.toggleSearch && _ctx.toggleSearch(...args)))
            }, _cache[30] || (_cache[30] = [
              _createElementVNode("i", { class: "fas fa-search" }, null, -1),
              _createTextVNode(" Search Exoplanets (2D) ")
            ])),
            (_ctx.currentTool !== 'sky-survey')
              ? (_openBlock(), _createElementBlock("li", {
                  key: 0,
                  class: "hamb-menu-items",
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.toggleCrossfadeSky && _ctx.toggleCrossfadeSky(...args)))
                }, _cache[31] || (_cache[31] = [
                  _createElementVNode("i", { class: "fas fa-adjust" }, null, -1),
                  _createTextVNode(" Crossfade Sky Survey (2D) ")
                ])))
              : (_openBlock(), _createElementBlock("li", {
                  key: 1,
                  class: "hamb-menu-items",
                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.toggleCrossfadeSky && _ctx.toggleCrossfadeSky(...args)))
                }, _cache[32] || (_cache[32] = [
                  _createElementVNode("i", { class: "fas fa-clock" }, null, -1),
                  _createTextVNode(" Discovery Timeline ")
                ]))),
            _createElementVNode("li", {
              class: "hamb-menu-items",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.openLink('https://www.rocketcenter.com/INTUITIVEPlanetarium/InteractiveAstronomy')))
            }, _cache[33] || (_cache[33] = [
              _createElementVNode("i", { class: "fas fa-solid fa-rocket" }, null, -1),
              _createElementVNode("i", null, " INTUITIVE", -1),
              _createElementVNode("sup", null, "®", -1),
              _createTextVNode(" Planetarium ")
            ])),
            _createElementVNode("li", {
              class: "hamb-menu-items",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.openLink('https://worldwidetelescope.org/')))
            }, _cache[34] || (_cache[34] = [
              _createElementVNode("img", {
                alt: "WWT Logo",
                src: _imports_0,
                width: "18",
                height: "18",
                style: {"vertical-align":"middle"}
              }, null, -1),
              _createTextVNode(" WorldWide Telescope ")
            ])),
            _createElementVNode("li", {
              class: "hamb-menu-items",
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.openLink('https://exoplanetarchive.ipac.caltech.edu/')))
            }, _cache[35] || (_cache[35] = [
              _createElementVNode("img", {
                alt: "NASA",
                src: "https://upload.wikimedia.org/wikipedia/commons/e/e5/NASA_logo.svg",
                width: "22",
                height: "22",
                style: {"vertical-align":"middle"}
              }, null, -1),
              _createTextVNode(" Exoplanet Archive ")
            ]))
          ], 2)
        ]),
        _createVNode(_Transition, { name: "intro-fade" }, {
          default: _withCtx(() => [
            (_ctx.showIntro)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "intro-backdrop",
                  onClick: _cache[13] || (_cache[13] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.closeIntro && _ctx.closeIntro(...args)), ["self"]))
                }, [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("button", {
                      class: "intro-modal-close",
                      onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.closeIntro && _ctx.closeIntro(...args))),
                      "aria-label": "Close"
                    }, _cache[36] || (_cache[36] = [
                      _createElementVNode("i", { class: "fas fa-times" }, null, -1)
                    ])),
                    _cache[41] || (_cache[41] = _createElementVNode("div", { class: "intro-modal-logos" }, [
                      _createElementVNode("a", {
                        href: "https://www.rocketcenter.com/INTUITIVEPlanetarium",
                        target: "_blank"
                      }, [
                        _createElementVNode("img", {
                          alt: "INTUITIVE Planetarium at the U.S. Space & Rocket Center",
                          src: _imports_1,
                          class: "intro-logo-ip"
                        })
                      ]),
                      _createElementVNode("div", { class: "intro-logo-row" }, [
                        _createElementVNode("a", {
                          href: "https://www.cosmicds.cfa.harvard.edu/",
                          target: "_blank",
                          class: "intro-logo-attr"
                        }, [
                          _createElementVNode("img", {
                            alt: "CosmicDS",
                            src: "https://static.wixstatic.com/media/446f6c_f07666e200744b08bb3a0a3c108887f5~mv2.png",
                            class: "intro-logo-cds"
                          }),
                          _createElementVNode("span", null, "Interactive developed using the CosmicDS toolkit")
                        ])
                      ]),
                      _createElementVNode("div", { class: "intro-logo-row" }, [
                        _createElementVNode("a", {
                          href: "https://worldwidetelescope.org/home/",
                          target: "_blank",
                          class: "intro-logo-attr"
                        }, [
                          _createElementVNode("img", {
                            alt: "WorldWide Telescope",
                            src: _imports_0,
                            class: "intro-logo-wwt"
                          }),
                          _createElementVNode("span", null, "Powered by WorldWide Telescope")
                        ])
                      ])
                    ], -1)),
                    _createElementVNode("h1", _hoisted_5, _toDisplayString(_ctx.introTitle), 1),
                    _cache[42] || (_cache[42] = _createElementVNode("div", { class: "intro-audio-notice" }, [
                      _createElementVNode("i", { class: "fas fa-volume-up" }),
                      _createElementVNode("span", null, "Turn on audio and raise your volume for the best experience.")
                    ], -1)),
                    _createElementVNode("div", _hoisted_6, [
                      _createVNode(_Transition, { name: "intro-arrow-fade" }, {
                        default: _withCtx(() => [
                          (_ctx.introCanScrollUp)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: "intro-scroll-hint intro-scroll-up",
                                onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.introScrollBody(-120)))
                              }, _cache[37] || (_cache[37] = [
                                _createElementVNode("i", { class: "fas fa-chevron-up" }, null, -1)
                              ])))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }),
                      _createElementVNode("div", {
                        class: "intro-modal-body",
                        ref: "introBody",
                        onScroll: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.onIntroBodyScroll && _ctx.onIntroBodyScroll(...args)))
                      }, _cache[38] || (_cache[38] = [
                        _createElementVNode("p", null, [
                          _createTextVNode(" Explore all 6,160 known exoplanets — planets discovered beyond our solar system — rendered in "),
                          _createElementVNode("a", {
                            href: "https://worldwidetelescope.org/home/",
                            target: "_blank",
                            class: "links"
                          }, "WorldWide Telescope"),
                          _createTextVNode(" in both 2D sky view and 3D galaxy view. Each exoplanet is color-coded by how it was discovered. Exoplanet data was retrieved from the "),
                          _createElementVNode("a", {
                            href: "https://exoplanetarchive.ipac.caltech.edu/",
                            target: "_blank",
                            class: "links"
                          }, "NASA Exoplanet Archive"),
                          _createTextVNode(". ")
                        ], -1),
                        _createElementVNode("div", { class: "intro-how-to" }, [
                          _createElementVNode("h2", { class: "intro-section-title" }, "How to Use"),
                          _createElementVNode("ul", { class: "intro-instructions" }, [
                            _createElementVNode("li", null, [
                              _createElementVNode("span", { class: "intro-icon" }, [
                                _createElementVNode("i", { class: "fas fa-arrows-alt" })
                              ]),
                              _createElementVNode("span", null, [
                                _createElementVNode("strong", null, "Navigate:"),
                                _createTextVNode(" Click & drag (or touch drag) to pan. Scroll wheel or pinch to zoom.")
                              ])
                            ]),
                            _createElementVNode("li", null, [
                              _createElementVNode("span", { class: "intro-icon" }, [
                                _createElementVNode("i", { class: "fas fa-rocket" })
                              ]),
                              _createElementVNode("span", null, [
                                _createElementVNode("strong", null, "Switch views:"),
                                _createTextVNode(" Press "),
                                _createElementVNode("em", null, "View 3D Galaxy"),
                                _createTextVNode(" / "),
                                _createElementVNode("em", null, "View 2D Sky"),
                                _createTextVNode(" to toggle between an all-sky star chart and a 3D Milky Way.")
                              ])
                            ]),
                            _createElementVNode("li", null, [
                              _createElementVNode("span", { class: "intro-icon" }, [
                                _createElementVNode("i", { class: "fas fa-mouse-pointer" })
                              ]),
                              _createElementVNode("span", null, [
                                _createElementVNode("strong", null, "Identify (desktop):"),
                                _createTextVNode(" Hover over a dot to see its name, discovery method, and distance — and hear its orbital-period tone.")
                              ])
                            ]),
                            _createElementVNode("li", null, [
                              _createElementVNode("span", { class: "intro-icon" }, [
                                _createElementVNode("i", { class: "fas fa-circle-dot" })
                              ]),
                              _createElementVNode("span", null, [
                                _createElementVNode("strong", null, "Identify (mobile):"),
                                _createTextVNode(" Use the "),
                                _createElementVNode("i", { class: "fas fa-circle-dot" }),
                                _createTextVNode(" button to enable the planet reticle. Pan the sky so an exoplanet enters the reticle ring to hear its tone and see its details. Tap the button again to dismiss it.")
                              ])
                            ]),
                            _createElementVNode("li", null, [
                              _createElementVNode("span", { class: "intro-icon" }, [
                                _createElementVNode("i", { class: "fas fa-music" })
                              ]),
                              _createElementVNode("span", null, [
                                _createElementVNode("strong", null, "Sonify:"),
                                _createTextVNode(" Press "),
                                _createElementVNode("em", null, "Play"),
                                _createTextVNode(" to hear exoplanet discoveries unfold through time — each planet's orbital period maps to a guitar note.")
                              ])
                            ]),
                            _createElementVNode("li", null, [
                              _createElementVNode("span", { class: "intro-icon" }, [
                                _createElementVNode("i", { class: "fas fa-sliders-h" })
                              ]),
                              _createElementVNode("span", null, [
                                _createElementVNode("strong", null, "Timeline:"),
                                _createTextVNode(" Drag the year slider to filter which exoplanets are shown by their discovery date.")
                              ])
                            ]),
                            _createElementVNode("li", null, [
                              _createElementVNode("span", { class: "intro-icon" }, [
                                _createElementVNode("i", { class: "fas fa-layer-group" })
                              ]),
                              _createElementVNode("span", null, [
                                _createElementVNode("strong", null, "Discovery Types:"),
                                _createTextVNode(" Use the "),
                                _createElementVNode("em", null, "Discovery Types"),
                                _createTextVNode(" menu to show or hide planets by how they were found.")
                              ])
                            ]),
                            _createElementVNode("li", null, [
                              _createElementVNode("span", { class: "intro-icon" }, [
                                _createElementVNode("i", { class: "fas fa-adjust" })
                              ]),
                              _createElementVNode("span", null, [
                                _createElementVNode("strong", null, "Sky surveys (2D only):"),
                                _createTextVNode(" Open "),
                                _createElementVNode("em", null, "Crossfade Sky Survey"),
                                _createTextVNode(" from the menu to blend between optical and other wavelength views, then tap "),
                                _createElementVNode("em", null, "Change Sky Survey"),
                                _createTextVNode(" to pick a dataset.")
                              ])
                            ])
                          ])
                        ], -1),
                        _createElementVNode("p", null, [
                          _createTextVNode(" Interactive created by "),
                          _createElementVNode("a", {
                            href: "https://bsky.app/profile/adavidweigel.bsky.social",
                            target: "_blank",
                            class: "links"
                          }, "A. David Weigel,"),
                          _createTextVNode(" Will Taylor, and "),
                          _createElementVNode("a", {
                            href: "https://www.jcarifio.com/projects",
                            target: "_blank",
                            class: "links"
                          }, "Jon Carifio.")
                        ], -1),
                        _createElementVNode("p", null, " Sonification created by Alex Shepard. ", -1),
                        _createElementVNode("p", null, [
                          _createTextVNode(" Special thanks to Faith Williams for UI suggestions and color theory advice and to the "),
                          _createElementVNode("a", {
                            href: "https://www.cosmicds.cfa.harvard.edu/",
                            target: "_blank",
                            class: "links"
                          }, "Cosmic Data Stories"),
                          _createTextVNode(" team for various creative advice. ")
                        ], -1)
                      ]), 544),
                      _createVNode(_Transition, { name: "intro-arrow-fade" }, {
                        default: _withCtx(() => [
                          (_ctx.introCanScrollDown)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: "intro-scroll-hint intro-scroll-down",
                                onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.introScrollBody(120)))
                              }, _cache[39] || (_cache[39] = [
                                _createElementVNode("i", { class: "fas fa-chevron-down" }, null, -1)
                              ])))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("button", {
                      class: "intro-modal-cta",
                      onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.closeIntro && _ctx.closeIntro(...args)))
                    }, _cache[40] || (_cache[40] = [
                      _createTextVNode(" Start Exploring "),
                      _createElementVNode("i", {
                        class: "fas fa-rocket",
                        style: {"margin-left":"0.4em"}
                      }, null, -1)
                    ]))
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        (_ctx.showSearch)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _withDirectives(_createElementVNode("input", {
                ref: "searchInput",
                class: "search-input",
                type: "text",
                placeholder: "e.g. 51 Peg b",
                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.searchQuery) = $event)),
                onInput: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.onSearchInput && _ctx.onSearchInput(...args))),
                onKeydown: [
                  _cache[16] || (_cache[16] = _withKeys(($event: any) => (_ctx.selectSearchResult(_ctx.searchResults[0])), ["enter"])),
                  _cache[17] || (_cache[17] = _withKeys(
//@ts-ignore
(...args) => (_ctx.toggleSearch && _ctx.toggleSearch(...args)), ["escape"]))
                ],
                autocomplete: "off",
                spellcheck: "false"
              }, null, 544), [
                [_vModelText, _ctx.searchQuery]
              ]),
              _createElementVNode("button", {
                class: "search-clear-btn",
                onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.toggleSearch && _ctx.toggleSearch(...args)))
              }, _cache[43] || (_cache[43] = [
                _createElementVNode("i", { class: "fas fa-times" }, null, -1)
              ])),
              (_ctx.searchResults.length)
                ? (_openBlock(), _createElementBlock("ul", _hoisted_8, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.searchResults, (pt) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: pt.name,
                        class: "search-result-item",
                        onClick: ($event: any) => (_ctx.selectSearchResult(pt))
                      }, [
                        _createElementVNode("span", _hoisted_10, _toDisplayString(pt.name), 1),
                        _createElementVNode("span", _hoisted_11, _toDisplayString(pt.cat), 1)
                      ], 8, _hoisted_9))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_12, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pings, (ping) => {
            return (_openBlock(), _createElementBlock("div", {
              key: ping.id,
              class: "ping-circle",
              style: _normalizeStyle({ left: ping.x + 'px', top: ping.y + 'px', '--ping-color': ping.color })
            }, null, 4))
          }), 128))
        ]),
        (_ctx.mobile && _ctx.modeReactive !== '3D')
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _createElementVNode("button", {
                class: _normalizeClass(["reticle-toggle-btn", { 'reticle-active': _ctx.reticleEnabled }]),
                onClick: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.toggleReticle && _ctx.toggleReticle(...args))),
                title: _ctx.reticleEnabled ? 'Identify mode on' : 'Identify mode off'
              }, _cache[44] || (_cache[44] = [
                _createElementVNode("svg", {
                  viewBox: "0 0 28 28",
                  class: "reticle-btn-icon"
                }, [
                  _createElementVNode("circle", {
                    cx: "14",
                    cy: "14",
                    r: "13",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "0.8",
                    "stroke-dasharray": "3 2",
                    opacity: "0.5"
                  }),
                  _createElementVNode("circle", {
                    cx: "14",
                    cy: "14",
                    r: "6",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "1.3"
                  }),
                  _createElementVNode("ellipse", {
                    cx: "14",
                    cy: "14",
                    rx: "11",
                    ry: "3.5",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "1.3",
                    transform: "rotate(-25 14 14)"
                  }),
                  _createElementVNode("text", {
                    x: "14",
                    y: "17.5",
                    "text-anchor": "middle",
                    "font-size": "7.5",
                    fill: "currentColor",
                    "font-family": "serif"
                  }, "♪")
                ], -1)
              ]), 10, _hoisted_14)
            ]))
          : _createCommentVNode("", true),
        (_ctx.mobile && _ctx.reticleEnabled && _ctx.modeReactive !== '3D')
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, _cache[45] || (_cache[45] = [
              _createElementVNode("svg", {
                viewBox: "0 0 120 120",
                xmlns: "http://www.w3.org/2000/svg"
              }, [
                _createElementVNode("circle", {
                  cx: "60",
                  cy: "60",
                  r: "55",
                  fill: "none",
                  stroke: "rgba(100,180,255,0.25)",
                  "stroke-width": "1",
                  "stroke-dasharray": "5 4"
                }),
                _createElementVNode("circle", {
                  cx: "60",
                  cy: "60",
                  r: "20",
                  fill: "none",
                  stroke: "rgba(100,180,255,0.8)",
                  "stroke-width": "1.5"
                }),
                _createElementVNode("ellipse", {
                  cx: "60",
                  cy: "60",
                  rx: "42",
                  ry: "12",
                  fill: "none",
                  stroke: "rgba(100,180,255,0.6)",
                  "stroke-width": "1.5",
                  transform: "rotate(-25 60 60)"
                }),
                _createElementVNode("circle", {
                  cx: "60",
                  cy: "60",
                  r: "2",
                  fill: "rgba(100,180,255,0.9)"
                })
              ], -1)
            ])))
          : _createCommentVNode("", true),
        _withDirectives(_createElementVNode("div", {
          id: "circle-popover",
          style: _normalizeStyle(_ctx.popoverCssVars)
        }, [
          _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.lastClosePt?.name), 1),
          _createElementVNode("div", _hoisted_17, [
            _createTextVNode(_toDisplayString(_ctx.lastClosePt?.cat) + ", " + _toDisplayString(_ctx.lastClosePt?.gdist.slice(0,6)) + " pc", 1),
            (_ctx.lastClosePt?.plOrbper)
              ? (_openBlock(), _createElementBlock("span", _hoisted_18, ", " + _toDisplayString(_ctx.lastClosePt.plOrbper.toFixed(1)) + " day orbit", 1))
              : _createCommentVNode("", true)
          ])
        ], 4), [
          [_vShow, _ctx.lastClosePt !== null && _ctx.modeReactive !== '3D' && !_ctx.showSkyPicker]
        ]),
        _withDirectives(_createElementVNode("button", {
          class: "catalog-button",
          onClick: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.openCatalog && _ctx.openCatalog(...args)))
        }, _toDisplayString(_ctx.showCatalog == true ? 'Collapse  Menu' : 'Discovery Types'), 513), [
          [_vShow, _ctx.showCatalogButton]
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", null, [
            _cache[46] || (_cache[46] = _createElementVNode("div", { class: "data-label" }, [
              _createElementVNode("p", { style: {"color":"#E3E3E3","font-size":"0.95rem"} }, " Discovery Types ")
            ], -1)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedCats, (cat, index) => {
              return (_openBlock(), _createBlock(_component_v_checkbox, {
                key: cat,
                color: _ctx.colors[index],
                modelValue: _ctx.layersOn[cat],
                "onUpdate:modelValue": ($event: any) => ((_ctx.layersOn[cat]) = $event),
                label: (cat.charAt(0).toUpperCase() + cat.slice(1)).replace('_', ' '),
                "label-color": _ctx.colors[index],
                "hide-details": ""
              }, {
                label: _withCtx(() => [
                  _createElementVNode("span", {
                    style: _normalizeStyle({ color: _ctx.colors[index] })
                  }, _toDisplayString((cat.charAt(0).toUpperCase() + cat.slice(1)).replace('_', ' ')), 5)
                ]),
                _: 2
              }, 1032, ["color", "modelValue", "onUpdate:modelValue", "label", "label-color"]))
            }), 128))
          ])
        ], 512), [
          [_vShow, _ctx.showCatalog]
        ]),
        _createElementVNode("div", _hoisted_20, [
          true
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.modeReactive = _ctx.modeReactive == '3D' ? '2D' : '3D'))
              }, [
                _createTextVNode(_toDisplayString(_ctx.modeReactive == '3D' ? 'View 2D Sky ' : 'View 3D Galaxy ') + " ", 1),
                _cache[47] || (_cache[47] = _createElementVNode("i", { class: "fas fa-solid fa-rocket" }, null, -1))
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["bg-slider-container", { 'sky-survey-mode': _ctx.currentTool === 'sky-survey' }])
        }, [
          (_ctx.currentTool == 'crossfade')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("button", {
                  type: "button",
                  class: "bg-slider-text play-btn",
                  onClick: _cache[22] || (_cache[22] = 
//@ts-ignore
(...args) => (_ctx.togglePlay && _ctx.togglePlay(...args)))
                }, _toDisplayString(_ctx.isPlaying ? 'Pause' : 'Play'), 1),
                _withDirectives(_createElementVNode("input", {
                  class: "opacity-range",
                  type: "range",
                  disabled: _ctx.isPlaying,
                  min: 0,
                  max: _ctx.totalMonths - 1,
                  "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.currentMonthIndex) = $event)),
                  onInput: _cache[24] || (_cache[24] = 
//@ts-ignore
(...args) => (_ctx.onSliderInput && _ctx.onSliderInput(...args)))
                }, null, 40, _hoisted_21), [
                  [_vModelText, _ctx.currentMonthIndex]
                ]),
                _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.monthName) + " " + _toDisplayString(_ctx.currentYear), 1)
              ], 64))
            : _createCommentVNode("", true),
          (_ctx.currentTool === 'sky-survey' && _ctx.modeReactive === '2D')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _withDirectives(_createElementVNode("div", _hoisted_23, [
                  _cache[48] || (_cache[48] = _createElementVNode("span", { class: "bg-slider-text cf-label" }, "Optical", -1)),
                  _withDirectives(_createElementVNode("input", {
                    class: "opacity-range",
                    type: "range",
                    min: "0",
                    max: "100",
                    "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.foregroundOpacity) = $event))
                  }, null, 512), [
                    [
                      _vModelText,
                      _ctx.foregroundOpacity,
                      void 0,
                      { number: true }
                    ]
                  ]),
                  _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.fgName), 1)
                ], 512), [
                  [_vShow, !_ctx.showSkyPicker]
                ]),
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("button", {
                    class: "bg-slider-text sky-picker-btn",
                    onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.showSkyPicker = !_ctx.showSkyPicker))
                  }, [
                    _cache[49] || (_cache[49] = _createElementVNode("i", {
                      class: "fas fa-layer-group",
                      style: {"margin-right":"4px"}
                    }, null, -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.showSkyPicker ? 'Select a survey…' : 'Change Sky Survey') + " ", 1),
                    _createElementVNode("i", {
                      class: _normalizeClass(_ctx.showSkyPicker ? 'fas fa-chevron-down' : 'fas fa-chevron-up'),
                      style: {"margin-left":"4px"}
                    }, null, 2)
                  ]),
                  _withDirectives(_createElementVNode("div", _hoisted_26, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allSkyImagesets, (survey) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: survey,
                        class: _normalizeClass(["sky-picker-item", { 'sky-picker-selected': _ctx.fgName === survey }]),
                        onClick: ($event: any) => {_ctx.fgName = survey; _ctx.showSkyPicker = false}
                      }, _toDisplayString(survey), 11, _hoisted_27))
                    }), 128))
                  ], 512), [
                    [_vShow, _ctx.showSkyPicker]
                  ])
                ])
              ], 64))
            : _createCommentVNode("", true)
        ], 2)
      ])
    ]),
    _: 1
  }, 8, ["style"]))
}